import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  texto!: string;
  footer = false;

  constructor() { }

  ngOnInit() {

    if(environment.name_service == 'localhost-nologin'){
      this.texto = '[ ENTORNO DE DESARROLLO - LOCAL ]';
      this.footer = true;
    }

    if(environment.name_service == 'desarrollo'){
      this.texto = '[ ENTORNO DE DESARROLLO ]';
      this.footer = true;
    }
  }
}
